import React from 'react'
import classes from './Breadcumb.module.scss'
import { headers } from '../../configs/constants/pageHeader'
import { useTranslation } from 'react-i18next'
import { store } from '../../index'
import { Permission } from '../../configs/constants/roles.const'

const BreadCumb = (props: any) => {
  const { t } = useTranslation()
  const mainHeader = (props.history.location.pathname as string).split('/')[1]

  return (
    <div className={classes.Breadcumb}>
      <ul className={classes.Tabs}>
        {(headers as any)[mainHeader]?.map((tab: any, index: number) => {
          const userInfo = store.getState().loginReducer.userInfo
          const hasRole = tab.role.includes(userInfo.role)
          let hasPermission = true

          if (tab.permissions?.length) {
            tab.permissions.forEach((permission: string) => {
              switch (permission) {
                case Permission.EAI_LICENSES:
                  hasPermission = userInfo.eaiLicensesPermission === 1
                  break
                case Permission.PRODUCT_PERMISSION:
                  hasPermission = userInfo.productManagementPermission === 1
                  break
              }
            })
          }

          if (!hasRole || !hasPermission) return null

          return (
            <div key={index.toString()}>
              <li style={index === 0 ? { marginLeft: '0' } : {}}>
                <a
                  style={mainHeader === tab.link.split('/')[1] ? { color: 'red' } : {}}
                  href={tab.link}>
                  {t(tab.name)}
                </a>
              </li>
            </div>
          )
        })}
      </ul>
    </div>
  )
}

export default BreadCumb
